import ReactDOMServer from 'react-dom/server'
import {GoogleApiWrapper} from 'google-maps-react';
import React from 'react'
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import {toggleCalculateRoute, toggleRoundTrip, onDirectionsChanged, onMapClicked } from './actions'

const camelize = function(str) {
  return str.split(' ').map(function(word){
    return word.charAt(0).toUpperCase() + word.slice(1);
  }).join('');
}

export class Map extends React.Component {
  constructor(props) {
    super(props);
  }

  updateMap() {
    console.log('updating path for polylinePath, From/ToMarker')
    this.Polyline && this.Polyline.setPath(this.props.polylinePath)
    this.StartMarker && this.props.markers[0] && this.StartMarker.setPosition(this.props.markers[0])
    this.EndMarker && this.props.markers[1] && this.EndMarker.setPosition(this.props.markers[1])

    // remove markers from map or reattach, depending on if we're using DirectionsService
    if (this.map) { //set to false to debug mismatch in autocompletes and map
      this.StartMarker && (this.props.markers[0]==null) ? this.StartMarker.setMap(null) : this.StartMarker.setMap(this.map)

      this.EndMarker && (this.props.markers[1]==null) ? this.EndMarker.setMap(null) : this.EndMarker.setMap(this.map)
    }

    if (this.map && this.Polyline && this.props.polylinePath.length>0 ) {
      console.log('set bounds from polyline')
      this.map.fitBounds(this.Polyline.getBounds())
      // zoomToObject(this.Polyline, window.google, this.map)

    }

    if (this.map && this.props.bounds) {
      // this.map.fitBounds(this.props.bounds)


    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.props)!== JSON.stringify(prevProps)) {
      console.log('componentDidUpdate')
      this.updateMap()
    }

    if (prevProps.google !== this.props.google) {
      this.loadMap();
    }

    if (JSON.stringify(this.props.directions) !== JSON.stringify(prevProps.directions)) {
      console.log("directions have changed", this.props.directions, prevProps.directions)
      const { DirectionsRenderer } = this

      if (this.props.directions == null) {
        return DirectionsRenderer && DirectionsRenderer.setMap(null)
      }

      if (!this.props.directions.routes) return

      if (this.props.directions && DirectionsRenderer) {
        DirectionsRenderer.setMap(this.map)
        DirectionsRenderer.setDirections(this.props.directions);
      }
    }

    if (prevProps.center !== this.props.center) this.recenterMap();

  }

  componentDidMount() {
    this.loadMap();
  }

  recenterMap() {
    const google = this.props.google;

    if (this.map) {
        this.map.panTo(this.props.center)
        this.map.setZoom(this.props.zoom)
    }
  }

  loadMap() {
    if (this.props && this.props.google) {
      window.google = this.props.google
      // google is available
      const {google, origin, destination} = this.props;
      const node = ReactDOM.findDOMNode(this.refs.map)

      this.map = new google.maps.Map(node, {
        center: new google.maps.LatLng(this.props.center),
        zoom: this.props.zoom,
        gestureHandling: "cooperative",
      });

      const evtNames = ['ready', 'click', 'dragend']
      evtNames.forEach(e => {
        this.map.addListener(e, this.handleEvent(e));
      });

      google.maps.event.trigger(this.map, 'ready');

      // initialize directions

      this.DirectionsRenderer = new google.maps.DirectionsRenderer({
        draggable: true,
        polylineOptions: {
          strokeColor: '#3995FD',
          strokeWeight: 10,
          strokeOpacity: 0.7,
        },
        map: this.map
      })

      this.DirectionsRenderer.addListener('directions_changed', ()=>{
        const directions = this.DirectionsRenderer.getDirections()
        this.props.dispatch(onDirectionsChanged(directions))

      })
      this.StartMarker = new google.maps.Marker({
        draggable: true,
        map: this.map,
        position: null,
        animation: google.maps.Animation.DROP,
        icon: {
            path: 'M25,42.5c-9.66498,0 -17.5,-7.83502 -17.5,-17.5l0,0c0,-9.66498 7.83502,-17.5 17.5,-17.5l0,0c9.66498,0 17.5,7.83502 17.5,17.5l0,0c0,9.66498 -7.83502,17.5 -17.5,17.5z',
            fillColor: '#31b59f',
            strokeOpacity: 0.5,
            fillOpacity: 1,
            scale: 0.5,
            strokeColor: '#31b59f',
            strokeWeight: 7,
            anchor: new google.maps.Point(30,30)
          }
      })
      this.EndMarker = new google.maps.Marker({
        draggable: true,
        position: null,
        map: this.map,
        animation: google.maps.Animation.DROP,
        icon: {
            path: 'M25,42.5c-9.66498,0 -17.5,-7.83502 -17.5,-17.5l0,0c0,-9.66498 7.83502,-17.5 17.5,-17.5l0,0c9.66498,0 17.5,7.83502 17.5,17.5l0,0c0,9.66498 -7.83502,17.5 -17.5,17.5z',
            fillColor: '#FF5166',
            strokeOpacity: 0.5,
            fillOpacity: 1,
            scale: 0.5,
            strokeColor: '#FF5166',
            strokeWeight: 7,
            anchor: new google.maps.Point(30,30)
          }
      })
      const icons = {fixedRotation: true, offset: '50px'}


      // google.maps.Polyline.prototype.getBounds = function() {
      //     var bounds = new google.maps.LatLngBounds();
      //     this.getPath().forEach(function(item, index) {
      //         bounds.extend(new google.maps.LatLng(item.lat(), item.lng()));
      //     });
      //     return bounds;
      // };

      google.maps.Polyline.prototype.getBounds = function() {
        var bounds = new google.maps.LatLngBounds();
        this.getPath().forEach(function(e) {
          bounds.extend(e);
        });
        return bounds;
      };


      var line = this.Polyline = new google.maps.Polyline({
        map: this.map,
        // geodesic: true,
        strokeColor: '#3995FD',//'#39b59e',
        strokeOpacity: 0.8,
        strokeWeight: 8,
        // editable: true,
        // draggable: true,
        path: this.props.polylinePath
      })

      var dispatch = this.props.dispatch
      const {onPolylineClick, onMapClicked} = this.props

      google.maps.event.addListener(this.map, 'click', onMapClicked);

      google.maps.event.addListener(this.EndMarker, 'dragstart', onPolylineClick);
      google.maps.event.addListener(this.StartMarker, 'dragstart', onPolylineClick);
      google.maps.event.addListener(line, 'mousedown', onPolylineClick);

    }

  }

  handleEvent(evtName) {
    let timeout;
    const handlerName = `on${camelize(evtName)}`;

    return (e) => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      timeout = setTimeout(() => {
        if (this.props[handlerName]) {
          this.props[handlerName](this.props, this.map, e);
        }
      }, 0);
    }
  }

  renderChildren() {
    const {children} = this.props;
    if (!children) return;
    return React.Children.map(children, child => {
      if (!child) return
      return React.cloneElement(child, {
        map: this.map,
        google: this.props.google,
        mapCenter: this.props.center
      });
    })
  }

  render() {
    return (
      <div ref='map' style={{
        width: '100%',
        // height: '100vh',
        'minHeight': '80vmin',
        // 'max-height': '100%',
        borderRadius: '4px'
      }}>
        Loading map...
        {this.renderChildren()}

      </div>
    )
  }
}


const mapStateToProps = ({map}, ownProps) => {
  return {
    ...map,
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onMapClicked:(v)=>dispatch(onMapClicked(v)),
    dispatch
  }
}
const ConnectedMap = connect(mapStateToProps, mapDispatchToProps)(Map)

export default GoogleApiWrapper({
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY
})(ConnectedMap)



// WEBPACK FOOTER //
// ./src/map/Map.js